/* eslint-disable prettier/prettier */
import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';

import { NavBarMode, PageRoute } from '../../components/NavBar';

const commonRoutes: PageRoute[] = [
  {
    name: 'HOW-TO',
    route: 'https://howto.westmonroe.com/a/1969049',
    external: true,
  },
];

const defaultNigelRoutes: PageRoute[] = [
  {
    name: 'News',
    route: 'https://howto.westmonroe.com/a/1971532',
    external: true,
  },
  ...commonRoutes,
];

const defaultDealGPTRoutes: PageRoute[] = [
  {
    name: 'Projects',
    route: '/intellio-advantage',
  },
  {
    name: 'Library',
    route: '/question-library',
  },
  ...commonRoutes,
];

interface NavBarRoutesContextType {
  routes: PageRoute[];
  setAppMode: (mode: NavBarMode) => void;
}

export const NavBarRoutesContext = createContext<NavBarRoutesContextType | null>(null);

interface Props {
  children: React.ReactNode;
}

export const NavBarRoutesProvider: React.FC<Props> = ({ children }) => {
  const [routes, setRoutes] = useState<PageRoute[]>(defaultNigelRoutes);
  const [currentAppMode, setCurrentAppMode] = useState<NavBarMode>(NavBarMode.NIGEL);

  useEffect(() => {
    if (currentAppMode === NavBarMode.NIGEL) {
      setRoutes(defaultNigelRoutes);
    } else if (currentAppMode === NavBarMode.DEALGPT) {
      setRoutes(defaultDealGPTRoutes);
    } else if (currentAppMode === NavBarMode.BLANK) {
      setRoutes([]);
    }
  }, [currentAppMode]);

  const setAppMode = useCallback((mode: NavBarMode) => {
    setCurrentAppMode(mode);
  }, []);

  return (
    <NavBarRoutesContext.Provider value={{ routes, setAppMode }}>
      {children}
    </NavBarRoutesContext.Provider>
  );
};

export const useNavBarRoutes = (): NavBarRoutesContextType => {
  const navBarRoutesContext = useContext(NavBarRoutesContext);

  if (!navBarRoutesContext) {
    throw new Error('useNavBarRoutes must be used within a NavBarRoutesProvider');
  }

  return navBarRoutesContext;
};
